<template>
    <div class="unitmeasure">
          <PageTitle icon="fa fa-clone" main="Registro" sub="Unidade de Medidas" />
         <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input id="unitmeasure-id" type="hidden" v-model="unitmeasure.id" />
             <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Descrição:" label-for="unitmeasure-name">
                        <b-form-input id="unitmeasure-name" type="text" ref="searchFocus"
                            v-model="unitmeasure.name" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Descrição..." />
                    </b-form-group>
                </b-col>    
                <b-col md="6" sm="12">
                    <b-form-group label="Sigla:" label-for="unitmeasure-initials">
                        <b-form-input id="unitmeasure-initials" type="text" 
                            v-model="unitmeasure.initials" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Sigla..." />
                    </b-form-group>
                </b-col>

             </b-row>

         </b-form>
            <hr v-show="mode === 'save'">
              <b-row >
                <b-col xs="12">
                    <b-button  
                        title="Adicionar" 
                        size="sm" 
                        class="mt-2 mb-2 fa fa-plus" 
                        variant="dark" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo"></b-button>
                    <b-button  
                        title="Salvar"  
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save"></b-button>
                    <b-button  
                        title="Excluir" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove"></b-button>
                    <b-button  
                        title="Voltar" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset"></b-button>
                    <b-button  
                    size="sm" 
                    title="Pesquisar" 
                    class="mt-2 mb-2 ml-2 fa fa-search" 
                    @click="[loadunitmeasures(),toggleBusy(),showTable = !showTable]" 
                    variant="dark" 
                    v-show="mode !== 'save' && mode !== 'remove'"
                    >
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
            <div class="col-sm-6">
                <b-form-group> 
                <input 
                    size="lg" 
                    type="text" 
                    icon="search" 
                    v-model="search" 
                    placeholder="Informe a descrição/sigla" 
                    class="form-control">                  
                </b-form-group>
            </div>
           <transition  name="slide" type="animation" appear>          
            <b-table  
                 :busy="isBusy"
                class="table-responsive" 
                v-show="showTable" 
                hover 
                key="slide" 
                head-variant="light" 
                 :items="filteredList" 
                 :fields="fields">
                  <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Carregando...</strong>
                        </div>
                    </template>
                <template v-slot:cell(actions)="data">
                        <b-button 
                             title="Visualizar"
                             size="sm" 
                             variant="light" 
                             @click="loadunitmeasure(data.item)" 
                             class="mr-2 mt-2">
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button 
                             size="sm" 
                              title="Editar" 
                             variant="light" 
                             @click="loadunitmeasure(data.item, 'remove')" 
                             class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>   
            </b-table>    
           </transition>
            <b-pagination 
              v-model="currentPage" 
              :per-page="perPage" 
               v-show="showTable" 
              :total-rows="rows">
              </b-pagination> 
           </b-row>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from "../template/PageTitle";

export default {
    name: 'UnitMeasure',
    components: { PageTitle},
    data: function() {
        return {
            mode: 'insert',
            search: '',
            unitmeasure: {},
            unitmeasures: [],
            showTable: false,
            isBusy: false,
            currentPage: 1,
            perPage: 5,
            fields: [
                { key: 'name', label: 'Descrição', sortable: true },
                { key: 'initials', label: 'Sigla', sortable: false },
                { key: 'actions', label: 'Ações' }
            ]
        }
    },
     computed: {
        filteredList() {
        return this.unitmeasures.filter(unitmeasure => {
        return (
                unitmeasure.name.toLowerCase().includes(this.search.toLowerCase()),
                unitmeasure.initials.toLowerCase().includes(this.search.toLowerCase())

                )
            })
        },
         icon() {
            return this.showTable ? "fa-retweet" : "fa-search"
        }
    },
    methods: {
        loadunitmeasures() {
            const url = `${baseApiUrl}/unitmeasures`
            axios.get(url).then(res => {
                this.unitmeasures = res.data
                this.isBusy = false
            })
        },
        reset() {
            this.mode = 'insert'
            this.loadunitmeasures()
        },
        toggleBusy() {
                    this.isBusy = !this.isBusy
                },
        alterModo() {
                    this.mode = 'save'
                    this.unitmeasure = {}
            },
        save() {
            const method = this.unitmeasure.id ? 'put' : 'post'
            const id = this.unitmeasure.id ? `/${this.unitmeasure.id}` : ''
            axios[method](`${baseApiUrl}/unitmeasures${id}`, this.unitmeasure)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        remove() {
            const id = this.unitmeasure.id
            axios.delete(`${baseApiUrl}/unitmeasures/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        loadunitmeasure(unitmeasure, mode = 'save') {
            this.mode = mode
            this.unitmeasure = { ...unitmeasure }

        }
    },
    mounted() {
        this.loadunitmeasures()
       this.showTable = true
    }
}
</script>

<style>


    .unitmeasure{
        font-size: 0.75rem;
    }
    .unitmeasure input{
        font-size: 0.75rem;
    }
    .unitmeasure button{
        font-size: 0.75rem;
    }

    .unitmeasure table{
        font-size: 0.75rem;
    }
    
    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
}

</style>
